exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-ad869cca] .el-table{font-size:13px}[data-v-ad869cca] .el-table .cell{line-height:14px}[data-v-ad869cca] .info-form .el-form-item{margin-bottom:15px}[data-v-ad869cca] .info-form .el-form-item__label{line-height:20px;padding-bottom:5px}[data-v-ad869cca] .info-form .el-input .el-input__inner{border-color:#fff!important}.monitor-name[data-v-ad869cca]{line-height:36px;font-size:16px;color:#fff}.monitor[data-v-ad869cca]{height:calc(100% - 36px);width:100%;cursor:pointer}", ""]);

// exports
